import { environment } from "../../environments/environment";
import { ClassdefinitionService } from "./classdefinition.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Obj} from "../model/object";


@Injectable()
export class DatasService {

  constructor(
    public httpClient: HttpClient,
    public classdefinitionService: ClassdefinitionService
  ) {}


  getList(classname: string, params) {
    let classDef = this.classdefinitionService.getByName(classname);

    if (!params) {
      params = {};
    }

    params["classname"] = classname;

    return this.httpClient
      .post(environment.apiUrl + "get-object-list", JSON.stringify(params))
      .toPromise()
      .then((res) => {
        return <any>res;
      })
      .then((res) => {
        // Log pour voir les échanges de données client/serveur
        //console.log(res.data);

        return {
          total: res.total,
          data: <Obj[]>res.data,
        };
      });
  }
}
